require('./angular-aria');
module.exports = 'ngAria';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-aria/index.js
 ** module id = 808
 ** module chunks = 8
 **/